
export default function Features() {
  const features = [
    {
      icon: 'ri-smartphone-line',
      title: 'iOS Native Development',
      description: 'Built specifically for iOS using the latest technologies and frameworks to ensure optimal performance and seamless integration with Apple devices.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Advanced Security',
      description: 'Industry-leading security protocols and encryption standards to protect your data and privacy at all times with zero compromises.'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'User-Friendly Interface',
      description: 'Intuitive and elegant design that makes our applications easy to use for everyone, regardless of technical expertise or experience level.'
    },
    {
      icon: 'ri-speed-line',
      title: 'High Performance',
      description: 'Optimized code and efficient algorithms ensure fast loading times and smooth operation without draining your device battery or resources.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features delivered through regular updates to keep your applications current with the latest iOS capabilities.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Dedicated Support',
      description: 'Professional customer support team ready to assist you with any questions or issues, ensuring a smooth and satisfying user experience.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <strong>Our Applications</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We combine cutting-edge technology with user-centric design to deliver exceptional mobile experiences
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-lg border border-gray-100 hover:shadow-lg transition-all duration-300">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500 rounded-lg mb-6">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
